// extracted by mini-css-extract-plugin
export var image = "section-module--image--3b1e9 asset-content-module--wrapper--0b4ba";
export var video = "section-module--video--1678c asset-content-module--wrapper--0b4ba";